import client from "../../../api/client";

export default async function updateRoomListing(listingId, payload) {
    const response = await client.patch(`/room-listings/${listingId}`, payload);
    return response.data;
}